import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=fd2c35e0"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=fd2c35e0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/julie/Works/openmetacity/Meta_Land-Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd2c35e0')) {
      api.createRecord('fd2c35e0', component.options)
    } else {
      api.reload('fd2c35e0', component.options)
    }
    module.hot.accept("./BaseModal.vue?vue&type=template&id=fd2c35e0", function () {
      api.rerender('fd2c35e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Modal/BaseModal.vue"
export default component.exports